import { render, staticRenderFns } from "./BonusHandle.vue?vue&type=template&id=659d683e&scoped=true"
import script from "./BonusHandle.vue?vue&type=script&lang=js"
export * from "./BonusHandle.vue?vue&type=script&lang=js"
import style0 from "./BonusHandle.vue?vue&type=style&index=0&id=659d683e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d683e",
  null
  
)

export default component.exports